module.exports = __webpack_public_path__ + "static/tombo-ea89852c2460ceddcbb8d85414d0203c.jpg";